<template>
        <div class="modal-card">

                    <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>

                    <header class="modal-card-head" >
 

             
                    </header>



                    <section class="modal-card-body">    
                        <!-- {{dataDetail}}           -->
                     
                    <b-table
                                :data="isEmpty ? [] : dataDetail "
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards
                             
                        >
                        
                        <b-table-column  label="No." width="3%"  v-slot="props">
                                 {{props.index + 1}}. 
                        </b-table-column>
                        <b-table-column  label="รหัส" width="8%"  v-slot="props">
                                  {{props.row.idpart  }} 
                        </b-table-column>
                        <b-table-column  label="รายการ"  v-slot="props">
                                  {{props.row.descp  }} 
                        </b-table-column>
                        <b-table-column  label=" จำนวน"  v-slot="props">
                                  {{formatStringToCurrency(props.row.amount)  }} 
                        </b-table-column>
                        <b-table-column  label="หน่วยนับ"  v-slot="props">
                                  {{props.row.unit_part_txt  }} 
                        </b-table-column>
                        <b-table-column  label="ราคาต่อหน่วย"  v-slot="props">
                                  {{ formatStringToCurrency(props.row.price)  }} 
                        </b-table-column>

                        <b-table-column  label="บันทึกเมื่อ"  v-slot="props">
                                    <span>
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).date }}  
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).month }} 
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).year }} 
                                    </span> 
                                        
                                    <span>
                                        {{  getISO8601ToYearMonthDate( props.row.dt_rec ).hour }}:{{  getISO8601ToYearMonthDate( props.row.dt_rec ).minute }} 
                                    </span>  
                        </b-table-column>

                        <b-table-column  label="บันทึกโดย"  v-slot="props">
                                  {{props.row.user_rec_fn  }}   
                        </b-table-column>       
                         

                        <b-table-column  label="Visit No/Job ID"  v-slot="props">
                                  {{  props.row.visit_no  }} 
                        </b-table-column>


                        <b-table-column  label="OPD No"  v-slot="props">
                                  {{  props.row.opd_no  }} 
                        </b-table-column>

                        <b-table-column  label="OPD Name"  v-slot="props">
                                  {{  props.row.opd_name  }} 
                        </b-table-column>

                        <b-table-column  label="Owner Name"  v-slot="props">
                                  {{  props.row.owner_fn  }} 
                        </b-table-column>

                        <b-table-column  label="Member ID"  v-slot="props">
                                  {{  props.row.member_id  }} 
                        </b-table-column>

                        <b-table-column  label="Member Name" width="20%" v-slot="props">
                                  {{  props.row.member_name  }} 
                        </b-table-column>


                        

                        <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                        </template>
                    </b-table>    
      
                   
                    
                    
                    </section>
                     <footer class="modal-card-foot"   style="justify-content: space-between;">
                        <b-button type="is-danger" @click="close">Close</b-button>      
                                        
                    </footer>



               



          

     </div>
</template>

<script>
import axios from "axios";
import { getBaseURLforBackEnd , getConfigAxios  } from '@/utils.js'
import { mapState } from 'vuex'
import formatStringToCurrency from '../../mixins/methods/formatStringToCurrency'
import getISO8601ToYearMonthDate from '../../mixins/methods/getISO8601ToYearMonthDate'


export default {
    name : "DlgDetailUsedPartByJobID",
    mixins:[formatStringToCurrency,getISO8601ToYearMonthDate,],
    props:{
        isShowing : Boolean,
        dataProp : String,
    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    computed:{
        ...mapState({
            access_token : state => state.master_data.access_token ,
		}),
    },    
    methods:{
        close(){
          this.$emit('close')
        },
        loadData(){
             this.isLoadingFullPage = true
             const datTo = {
                "invoice_no" :  this.dataProp
             }
             axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
             axios.post(`${getBaseURLforBackEnd()}/api/get_detail_usedpartpatho_from_invoice`,datTo,getConfigAxios())
                  .then((res)=>{
                      this.dataDetail = res.data
                      this.isLoadingFullPage = false
                  }) 
        }
    },
    data(){
        return{
            isLoadingFullPage: false,
            isEmpty : false,
            dataDetail : [],
        }
    },
    watch:{
        isShowing:{
            immediate: true,
            handler: function(val){
                 if(val){
                    this.loadData()  
                 }
                
            }
        }
    }
}
</script>